import { defineLegacyDefaultTheme } from './defineLegacyDefaultTheme';

/** An ethereal violet-indigo night. */
export const spiritTheme = defineLegacyDefaultTheme({
  id: 'Spirit',
  tokens: {
    a0: { l: 0.72, c: 0.16, h: 295 },
    a1: { l: 0.72, c: 0.16, h: 335 },
    a2: { l: 0.72, c: 0.16, h: 15 },
    a3: { l: 0.72, c: 0.16, h: 55 },
    a4: { l: 0.72, c: 0.16, h: 95 },
    b0: { l: 0.16, c: 0.014, h: 295 },
    b1: { l: 0.2, c: 0.014, h: 295 },
    b2: { l: 0.24, c: 0.016, h: 295 },
    b3: { l: 0.27, c: 0.016, h: 295 },
    b4: { l: 0.31, c: 0.018, h: 295 },
    c0: { l: 0.93, c: 0.012, h: 295 },
    c1: { l: 0.84, c: 0.012, h: 295 },
    c2: { l: 0.74, c: 0.012, h: 295 },
    c3: { l: 0.64, c: 0.012, h: 295 },
    c4: { l: 0.56, c: 0.012, h: 295 },
  },
});
